define('collections/commons/locales',[
    'jquery',
    'underscore',
    'backbone',
    // models
    'models/commons/locale',
    // datafiles
    'text!assets/datafiles/locales.json'
], function($, _, Backbone, MLocale, LanguagesData) {

    var data = $.parseJSON(LanguagesData);

    var CLocales = Backbone.Collection.extend({
        url: 'assets/datafiles/languages.json',
        model: MLocale,
        initialize: function(models, opt) {
            // models = LanguagesData;
            this.set(data, { silent: true });
        },
    });

    return CLocales;

});

